import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonHLPure } from "../../pures"
import './ai-document-analysis.pure.css'

/**
 * @author Nestor Sandoval
 * @description AIDocumentAnalysisPure - Pure component for AI document analysis with chat and document viewer
 * @typedef {Object} Props
 * @property {Object} documentData - The document data object containing metadata
 * @property {string} documentUrl - The URL of the document to analyze
 * @property {string} blobUrl - The Blob URL for the selected PDF
 * @property {React.ReactNode} pdfViewer - The rendered PDF reader component
 * @property {Array<{role: 'user' | 'assistant', message: string, timestamp: Date}>} chatMessages - Array of chat messages
 * @property {string} userMessage - Current user message input
 * @property {boolean} isSending - Flag indicating if a message is being sent
 * @property {function} onMessageChange - Handler for message input change
 * @property {function} onSendMessage - Handler for sending a message
 * @property {function} onClose - Handler for closing the dialog
 * @param {Props} props - The component props
 * @returns {JSX.Element} The rendered component
 */

const AIDocumentAnalysisPure = ({
  documentData,
  documentUrl,
  pdfViewer,
  onClose
}) => {
  const { t } = useTranslation()

  // Construir la URL del iframe con los parámetros necesarios
  const buildIframeUrl = () => {
    const botId = '9b52f006-6f88-4f4b-bd4e-fc44e9dfbcff'
    const baseUrl = `https://assistant.atix.digital/?botId=${botId}`

    const versions = documentData?.versions || []

    // Find the main version (statusType: "mainDoc") or fall back to the first available version
    const mainVersion = versions.find(v => v.statusType === 'mainDoc') || versions[0]
    if (mainVersion?.id && mainVersion?.urlBase64) {
      const versionId = mainVersion.id
      const documentUrlBase64 = mainVersion.urlBase64 || mainVersion.url

      return `${baseUrl}&documentId=${versionId}&documentUrl=${documentUrlBase64}`
    }
    // Fallback: if no valid version with urlBase64, return base URL only
    return baseUrl
  }

  const iframeUrl = buildIframeUrl()

  return (
    <>
      <div className='ai-document-analysis-container'>
        <div className='ai-document-analysis-content'>
          <div className='ai-document-analysis-chat-section'>
            <iframe
              src={iframeUrl}
              width="100%"
              height="100%"
              title='Asistente Govo'
              style={{ border: 'none' }}
            />
          </div>

          <div className='ai-document-analysis-document-section'>
            <div className='ai-document-analysis-document-viewer'>
              {pdfViewer}
            </div>
          </div>

        </div>
      </div>
      <hr />
      <div className='ia-document-analysis-button-return'>
        <ButtonHLPure
          primary
          nameBtn={t("button.return")}
          onClickBtn={onClose}
        />
      </div>
    </>
  )
}

export default AIDocumentAnalysisPure
